import { weekStartEnd } from '@/libs/util.js'

let yestoday = {
    text: '昨 天',
    value() {
        let start = new Date(new Date().setHours(0, 0, 0, 0)) - 3600 * 1000 * 24
        start = new Date(parseInt(start / 1000) * 1000)
        return [start, start]
    }
}

let today = {
    text: '今 天',
    value() {
        const start = new Date(new Date().setHours(0, 0, 0, 0))
        const end = new Date(new Date(new Date().toLocaleDateString()).getTime())
        return [start, end]
    }
}

let recentWeek = {
    text: '最近一星期',
    value() {
        let start = new Date(new Date().setHours(0, 0, 0, 0)) - 3600 * 1000 * 24 * 6
        start = new Date(parseInt(start / 1000) * 1000)
        const end = new Date(new Date(new Date().toLocaleDateString()).getTime())
        return [start, end]
    }
}

let recentMonth = {
    text: '最近一个月',
    value() {
        let start = new Date(new Date().setHours(0, 0, 0, 0)) - 3600 * 1000 * 24 * 30
        start = new Date(parseInt(start / 1000) * 1000)
        const end = new Date(new Date(new Date().toLocaleDateString()).getTime())
        return [start, end]
    }
}

let recentThreeMonth = {
    text: '最近三个月',
    value() {
        let start = new Date(new Date().setHours(0, 0, 0, 0)) - 3600 * 1000 * 24 * 90
        start = new Date(parseInt(start / 1000) * 1000)
        const end = new Date(new Date(new Date().toLocaleDateString()).getTime())
        return [start, end]
    }
}

let thisWeek = {
    text: '本周',
    value() {
        return weekStartEnd(0)
    }
}

let lastWeek = {
    text: '上周',
    value() {
        return weekStartEnd(1)
    }
}

let last2ndWeek = {
    text: '上上周',
    value() {
        return weekStartEnd(2)
    }
}

let last3rdWeek = {
    text: '上上上周',
    value() {
        return weekStartEnd(3)
    }
}

export default {
    yestoday,
    today,
    recentWeek,
    recentMonth,
    recentThreeMonth,
    thisWeek,
    lastWeek,
    last2ndWeek,
    last3rdWeek
}
